export default __webpack_public_path__ + "static/media/error.64e3a0a1.svg";